module.exports = __webpack_public_path__ + "static/media/ectpl.b38f4b5f.jpg";